
// Project Endpoint
export const CREATE_PROJECT = '/project/create';
export const getLayers = id => `/project/${id}/layer/getLayers`;
export const getProjectById = id => `/project/${id}/get`;
export const putProjectName = id => `/project/${id}/update/name`;
export const putProjectModelDraft = (id, modelId) => `/project/${id}/update/model/${modelId}/draft`;
export const putValidateGraphEndpoint = id => `/project/${id}/validategraph`;
export const putGetNotebookEndpoint = id => `/project/${id}/getNotebook`;
export const getRecommendationEndpoint = (id, layerId) => `/project/${id}/layer/${layerId}/getRecommendation`;
export const getDuplicateProject = id => `/project/${id}/duplicate`;
export const getRemoveProject = id => `/project/${id}/delete`;

// Projects List Endpoints
export const GET_PROJECTS = '/project/getProjects';
export const GET_CONFIGS = '/project/configs';
